import {
  Content,
  ChartContainer,
  ColumnsContainer,
  ColumnsHeader,
  Container
} from './SaF.styles'
import { SaFProps } from './SaF.types'
import useSaFLinks from './useSaFLinks'
import SaFNodePair from './SaFNodePair'
import Text from '~/components/Text/Text'
import SaFTotals from './SaFTotals'
import { generateSankey, getNodeValues } from './safUtils/safUtils'
import { useTheme } from 'styled-components'
import React, { Fragment, useState } from 'react'
import useSaFColumnWidth from './useSaFColumnWidth'

type ColumnsProps = {
  columns: SaFProps['columns']
  columnWidth: number
}

const Columns = ({ columns, columnWidth }: ColumnsProps) => {
  return (
    <ColumnsContainer {...{ columnWidth }}>
      <ColumnsHeader {...{ columnWidth }}>
        {columns.map(
          (
            { nodeDescription, nodeComplement, nodeNote, linkDescription },
            index
          ) => (
            <Fragment key={index}>
              <div>
                <Text variant='content-emphasis-03' as='div'>
                  {nodeDescription}
                </Text>
                <Text variant='content-03' as='div'>
                  {nodeComplement}
                </Text>
                <Text variant='content-02' as='div'>
                  {nodeNote}
                </Text>
              </div>
              {index + 1 !== columns.length && (
                <Text variant='content-03'>{linkDescription}</Text>
              )}
            </Fragment>
          )
        )}
      </ColumnsHeader>
    </ColumnsContainer>
  )
}

export default React.memo(function SaF({ data, columns }: SaFProps) {
  const { saf: safTheme } = useTheme()

  const [chartOuterContainer, setChartOuterContainer] =
    useState<HTMLDivElement | null>(null)

  const columnsLength = columns.length

  const columnWidth = useSaFColumnWidth({
    chartOuterContainer,
    columnsLength,
    safTheme
  })

  const { nodes, links, nodesByDepth, width, height } = generateSankey({
    data,
    columnsLength,
    columnWidth,
    safTheme
  })

  const { linkLabels, linkPaths } = useSaFLinks({ links })

  const allNodes = nodes.map(({ index = 0, ...node }) => {
    return (
      <SaFNodePair
        key={index}
        {...node}
        {...getNodeValues(node)}
        colors={safTheme.nodeColors[index % safTheme.nodeColors.length]}
      />
    )
  })

  const contentWidth = columnWidth * columns.length

  return (
    <Container style={{ width: contentWidth }} ref={setChartOuterContainer}>
      <Content style={{ width: contentWidth }}>
        <Columns {...{ columns, columnWidth }} />
        <ChartContainer {...{ columnWidth }}>
          {linkLabels}
          {allNodes}
          <svg width={width} height={height}>
            {linkPaths}
          </svg>
          <SaFTotals {...{ nodesByDepth }} />
        </ChartContainer>
      </Content>
    </Container>
  )
})
